import { createDynamicSlice } from ".";
import { GetApprovalRequests, GetProductDetails, GetProductListing, GetVariantWithoutInventory, GetVendorProductDetails, SaveProduct, SaveStock } from "../thunks/productThunk";

const productListingSlice = createDynamicSlice({
  name: "productListingSlice",
  thunk: GetProductListing,
  listMode: true
});

const productDetailsSlice = createDynamicSlice({
  name: "productDetailsSlice",
  thunk: GetProductDetails,
});

const variantWithoutInventorySlice = createDynamicSlice({
  name: "variantWithoutInventorySlice",
  thunk: GetVariantWithoutInventory,
})

const saveStockSlice = createDynamicSlice({
  name: "saveStockSlice",
  thunk: SaveStock,
  resetActionName: "resetStock",
})

const saveProductSlice = createDynamicSlice({
  name: "saveProductSlice",
  thunk: SaveProduct,
  resetActionName: "resetProduct",
})

const approvalRequestsSlice = createDynamicSlice({
  name: "approvalRequestsSlice",
  thunk: GetApprovalRequests,
  listMode: true,
})

const vendorProductDetailsSlice = createDynamicSlice({
  name: "vendorProductDetailsSlice",
  thunk: GetVendorProductDetails,
})

export const productListingReducer = productListingSlice.reducer;
export const productDetailsReducer = productDetailsSlice.reducer;
export const variantWithoutInvntoryReducer = variantWithoutInventorySlice.reducer;
export const saveStockReducer = saveStockSlice.reducer;
export const saveProductReducer = saveProductSlice.reducer;
export const approvalRequestReducer = approvalRequestsSlice.reducer;
export const vendorProductDetailsReducer = vendorProductDetailsSlice.reducer;
export const {resetStock} = saveStockSlice.actions;
export const {resetProduct} = saveProductSlice.actions;